import React from 'react';
import {UseFormMethods, useWatch} from 'react-hook-form';
import {FormDataRaw} from '../types';
import {
  AddressHouseNumberInput,
  FormRow,
  GrowingTextInput,
  StyledTextInput,
  UserDetailsFieldSet,
  ZipCodeInput,
} from './styled';

interface Props {
  register: UseFormMethods['register'];
  isOrder: boolean;
  control: UseFormMethods['control'];
  labels: {
    personal_details_heading: string;
    house_number: string;
    street: string;
    address_additional_info: string;
    zip_code: string;
    city: string;
    birthDate: string;
  };
}

export const UserDetailsSection = ({
  register,
  isOrder,
  labels,
  control,
}: Props) => {
  const values = useWatch<FormDataRaw>({
    control,
    name: [
      'street',
      'houseNumber',
      'addressAdditional',
      'zipCode',
      'city',
      'birthDate',
    ],
  });

  return (
    <UserDetailsFieldSet
      hidden={!isOrder}
      label={labels.personal_details_heading}
      data-testid="hcUserDetailsSection"
    >
      <FormRow>
        <GrowingTextInput
          ref={register()}
          label={labels.street}
          name="street"
          value={values.street}
          isControlled={false}
          data-testid="hcUserStreetInput"
        />
        <AddressHouseNumberInput
          ref={register()}
          label={labels.house_number}
          name="houseNumber"
          value={values.houseNumber}
          isControlled={false}
          data-testid="hcUserHouseNoInput"
        />
      </FormRow>
      <StyledTextInput
        ref={register()}
        label={labels.address_additional_info}
        name="addressAdditional"
        value={values.addressAdditional}
        isControlled={false}
        data-testid="hcUserAdditionalAddressInput"
      />
      <FormRow>
        <ZipCodeInput
          ref={register()}
          label={labels.zip_code}
          name="zipCode"
          value={values.zipCode}
          isControlled={false}
          data-testid="hcUserZipCodeInput"
        />
        <GrowingTextInput
          ref={register()}
          label={labels.city}
          name="city"
          value={values.city}
          isControlled={false}
          data-testid="hcUserCityInput"
        />
      </FormRow>
      <StyledTextInput
        ref={register()}
        label={labels.birthDate}
        name="birthDate"
        value={values.birthDate}
        isControlled={false}
        data-testid="hcUserBirthDateInput"
      />
    </UserDetailsFieldSet>
  );
};
